import React from "react";
import { FiInfo } from "react-icons/fi";
import { Card } from "../ui/Card";
import Button from "../ui/Button";

export default function TermsSection({
  agreed,
  onAgreedChange,
  canSubmit,
  isSubmitting,
  submitError,
  onSubmit,
  onBack,
}) {
  return (
    <Card radius="panel">
      <div className="rma-nc-terms-note">
        <FiInfo className="rma-nc-terms-note-icon" size={18} strokeWidth={1.8} />
        <p className="rma-nc-terms-note-text">
          You’ll receive a confirmation notification with your reference number after
          submission. Please ensure all information provided is accurate, as incorrect or
          incomplete information may delay the processing of your request.
          <br />
          For warranty: <a href="mailto:support.au@dreame.tech">support.au@dreame.tech</a> · For
          DOA:{" "}
          <a href="mailto:rma@subemo.com">rma@subemo.com</a>
        </p>
      </div>

      <label className="rma-nc-terms-checkbox">
        <input
          type="checkbox"
          checked={agreed}
          onChange={(event) => onAgreedChange(event.target.checked)}
        />
        <span>
          I have read and agree to the <a href="#terms">Terms &amp; Conditions</a>
        </span>
      </label>

      {submitError && <p className="rma-nc-submit-error">{submitError}</p>}

      <div className="rma-nc-actions-row--split">
        {onBack && (
          <Button variant="secondary" size="lg" disabled={isSubmitting} onClick={onBack}>
            Back
          </Button>
        )}
        <Button
          block={!onBack}
          className={onBack ? "rma-nc-button--flex" : undefined}
          size="lg"
          disabled={!canSubmit}
          onClick={onSubmit}
        >
          {isSubmitting ? "Submitting…" : "Submit request"}
        </Button>
      </div>
    </Card>
  );
}
